<template>
  <div>
     <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div> 
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
          <!--   <v-flex xs12 class="text-xs-right" mt-1>
              <v-menu offset-y>
                <v-btn
                  slot="activator"
                  color="rgb(248 71 6)"
                  class="white--text list_notification"
                  @click="backtonotification()"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                    >arrow_back</v-icon
                  >
                  back
                </v-btn>
              </v-menu>
            </v-flex> -->
            <v-form
              id="createStationInventory"
              @submit.prevent="validateBeforeSubmit('createStationInventory')"
              data-vv-scope="createStationInventory"
              v-model="valid"
            >
              <v-card-text>
                <v-layout row wrap style="margin-bottom: 20px;">
                  <v-flex xs12 md12 lg8>
                    <v-radio-group
                        v-model="rail_type"
                        row
                    >
                      <v-radio
                          label="Local"
                          value="1"
                          color="#fd8955"
                      ></v-radio>
                      <v-radio
                          label="Metro"
                          value="2"
                          color="#fd8955"
                      ></v-radio>
                      <v-radio
                          label="Mono"
                          value="3"
                          color="#fd8955"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>


                  <v-flex xs12 md12 lg8 v-if="rail_type=='1'">
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Station :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Select Station"
                        name="Local_Station"
                        :items="stations.local_stations"
                        v-model="station_ads_inventory_object.station_id"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createStationInventory.Local_Station')
                        "
                        clearable solo flat
                    >
                    </v-autocomplete>
                  </v-flex>


                  <v-flex xs12 md12 lg8 v-else-if="rail_type=='2'">
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Station :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Select Station"
                        name="Metro_Station"
                        :items="stations.metro_stations"
                        v-model="station_ads_inventory_object.station_id"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createStationInventory.Metro_Station')
                        "
                        clearable solo flat
                    >
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 md12 lg8 v-else-if="rail_type=='3'">
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Station :</label>
                    </v-flex>
                    <v-autocomplete
                        label="Select Station"
                        name="Mono_Station"
                        :items="stations.mono_stations"
                        v-model="station_ads_inventory_object.station_id"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createStationInventory.Mono_Station')
                        "
                        clearable solo flat
                    >
                    </v-autocomplete>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Android-Ad-unit :</label>
                    </v-flex>
                    <v-text-field
                        name="Android-Ad-unit"
                        v-model="station_ads_inventory_object.android_ad_unit"
                        label="Create Android-Ad-unit"
                        v-validate="'required'"
                        clearable solo flat
                    ></v-text-field>
                    <div class="red--text pt-7" style="font-size: 13px;">
                      {{ error_message_android_ad_unit }}
                    </div>
                  </v-flex>



                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Ios-Ad-unit :</label>
                    </v-flex>
                    <v-text-field
                        name="Ios-Ad-unit"
                        v-model="station_ads_inventory_object.ios_ad_unit"
                        label="Create Ios-Ad-unit"
                        v-validate="'required'"
                        clearable solo flat
                    ></v-text-field>
                    <div class="red--text pt-7" style="font-size: 13px;">
                      {{ error_message_ios_ad_unit }}
                    </div>
                  </v-flex>


                  <v-flex xs12 md12 lg8>
                    <v-flex style="display: flex; flex-direction: row; justify-content: space-between;">
                      <label>Status :</label>
                    </v-flex>
                    <v-sheet class="pa-1 accent--text">
                      <v-switch
                          v-model="status"
                          color="#fd8955"
                          inset
                          :label="`${status == 1 ? 'Active' : 'Inactive'}`"
                      ></v-switch>
                    </v-sheet>
                  </v-flex>

                  <v-flex xs12 md12 lg8>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small :disabled="!valid" type="submit"
                    >create
                    </v-btn>
                    <v-btn flat small to="/stationAdsInventoryList">Cancel</v-btn>
                  </v-card-actions>
                  </v-flex>
                </v-layout>

              </v-card-text>

            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  data: () => {
    return {
      station_ads_inventory_object: {
        station_id:"",
        android_ad_unit: "",
        ios_ad_unit: "",
      },
      
      stations:[],
      error_message_android_ad_unit: "",
      error_message_ios_ad_unit: "",
      status: true,
      submit_loader: false,
      valid: false,
      rail_type:"1",
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
  watch: {
    
       "station_ads_inventory_object.android_ad_unit":{
        handler(val){
            if(val.length > 50){
              this.station_ads_inventory_object.android_ad_unit = '';
              this.error_message_android_ad_unit = "Invalid Android_Ads_Unit";  
            }
         }
       },

       "station_ads_inventory_object.ios_ad_unit":{
        handler(val){
          if(val.length > 50){
               this.station_ads_inventory_object.ios_ad_unit = '';
               this.error_message_ios_ad_unit = "Invaild Ios_Ads_Unit";
              
          }
        }
     }
  },

  methods: {
  
    // backtonotification:function(){
    //     this.$router.push({name:"Notifications"});
    // },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    createStationInventory: function () {
      this.submit_loader = true;
      let new_station_ads_inventory = Object.assign({}, this.station_ads_inventory_object);
      new_station_ads_inventory.station_id = this.station_ads_inventory_object.station_id.id;
      new_station_ads_inventory.rail_type = this.rail_type;
      new_station_ads_inventory.android_ad_unit = this.station_ads_inventory_object.android_ad_unit;
      new_station_ads_inventory.ios_ad_unit = this.station_ads_inventory_object.ios_ad_unit;
      new_station_ads_inventory.status = this.status;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/storeStation-Ads-Inventory`,new_station_ads_inventory,
           { headers: this.$headers }
        )
       
        .then((response) => {
          if (response.data.status == 1) {
            // console.log(response.data.notification_id);
            // this.notification_ID = response.data.notification_id.id;
            // this.$router.push({
            //   name: "notification",
            //   params: { id: this.notification_ID },
            // });

            this.submit_loader = true;
            this.snackBar.show = true;
            this.snackBar.message = response.data.message;
            this.$router.push({name:"StationAdsInventoryList"});  
          } else {
            // this.station_ads_inventory_object.station_id = '';
            // this.station_ads_inventory_object.android_ad_unit = '';
            // this.station_ads_inventory_object.ios_ad_unit = '';  
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                // console.log(response.data.stations);return;
                this.stations = response.data.stations;
                   
             }  
        })
    }
  },
   mounted(){
      this.getStations();
  },
};
</script>

<style type="text/css">
  .accent--text {
    color: #f67656;
    caret-color: #383859;
}
</style>

